import {useLayoutEffect} from 'react';

import type {ReactElement, ReactNode} from 'react';

// This studio's media-first design uses a consistent dark viewing environment.
export const ThemeProvider = ({children}: {readonly children: ReactNode}): ReactElement => {
  useLayoutEffect(() => {
    document.documentElement.classList.add('dark', 'scheme-dark');
  }, []);
  return <>{children}</>;
};
